import styled from 'styled-components';

import { mediaTopBarVisible } from '@xing-com/layout-tokens';

export const List = styled.ol`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const MediaConfined = styled.div`
  @media ${mediaTopBarVisible} {
    display: none;
  }
`;
